import {
  SET_FORECAST_GWC,
} from "./mutations";

const initialState = {
  currentForecastGWC: null,
};

const forecastGWCReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FORECAST_GWC:
      return { ...state, currentForecastGWC: payload }

    default:
      return state;
  }
};

export default forecastGWCReducer;
